import { gql } from 'urql';

const FetchRDCOptions = gql`
  query FetchRDCOptions {
    rdcOptions {
      __typename
      ... on RdcOptionsSuccess {
        id
        isFirstTime
        maxDeposit {
          amount
          currency
        }
        agreement {
          id
          resource {
            pdfDocument {
              id
              url
            }
          }
        }
      }
      ... on RdcOptionsActivateCard {
        code
        title
        message
        card {
          id
        }
      }
      ... on RdcOptionsBlocked {
        code
        title
        message
      }
      ... on RdcOptionsSetupDirectDeposit {
        code
        title
        message
      }
    }
  }
`;

export default FetchRDCOptions;
